export enum MultiSelectionMenuId {
  FontSize = 'FontSize',
  ThemeColor = 'ThemeColor',
  TextAlign = 'TextAlign',
  ZoneShape = 'ZoneShape',
  FontStrikethrough = 'FontStrikethrough',
  LinkLineStyle = 'LinkLineStyle',
  LinkMarkStyle = 'LinkMarkStyle',
  ReverseLink = 'ReverseLink',
  LinkColor = 'LinkColor',
  GroupStickyElements = 'GroupStickyElements',
  RemoveMultiSelectedLinks = 'RemoveMultiSelectedLinks',
  HorizontalAlignMenu = 'HorizontalAlignMenu',
  VerticalAlignMenu = 'VerticalAlignMenu',
}
